<template>
  <mf-loading-dialog :loading="loadingDialog">
    <base-page-layout title="Resultados da campanha" hide-ecommerce-configuration use-new-filters :filters="['lojas']" :filter-to-units="campaignUnitIds">
      <v-row>
        <v-col>
          <info-card
            :title="campaign.title"
            :description="campaign.description"
            :date="campaign.message.send_date"
            :time="campaign.message.send_time"
            :segments="campaign.segments"
            :products="campaign.products"
            :initial-date="campaign.initial_date"
            :final-date="campaign.final_date"
            :status="campaign.status"
            :frequency="campaign.frequency"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pl-4">
          <span class="section-title">Resultados do disparo</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <email-preview :title="campaign.message.subject" :html-content="campaign.message.processed_html" />
        </v-col>
        <v-col cols="6">
          <v-row>
            <v-col v-for="(card, index) in cardsDisparo" :key="`1-${index}`" cols="6" class="pt-0">
              <cbm-card
                :number-text="card.value"
                :title="card.text"
                :is-currency="card.isCurrency"
                :percent-text="card.underText"
                :percent-description="card.description"
                :boolean-loader="loadingMetrics"
                unset-percentage-colors
              />
            </v-col>
            <v-col v-for="(card, index) in cards" :key="`2-${index}`" cols="6" class="pt-0">
              <cbm-card
                :number-text="card.value"
                :title="card.text"
                :is-currency="card.isCurrency"
                :percent-text="card.underText"
                :percent-description="card.description"
                :boolean-loader="loadingMetrics"
                :tooltip="card.helpText"
                unset-percentage-colors
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <funnel base-metric="opened" :loading="loadingMetrics" :metrics="metrics" :campaign="campaign" :units-configuration="unitsConfiguration" />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <products-table base-metric="opened" :loading="loadingMetrics" :metrics="metrics" :campaign="campaign" :units-configuration="unitsConfiguration" />
        </v-col>
      </v-row>
      <mf-action-buttons :primary-button="primaryButton" :cancel-button="cancelButton" />
    </base-page-layout>
  </mf-loading-dialog>
</template>

<script>
// import { QUERY_GET_RESULT_METRICS_EMAIL_CAMPAIGN_BY_ID } from './graphql'
import { QUERY_GET_CAMPAIGN_METRICS } from '@/modules/campanhas/views/components/graphql'
import { localeString } from '@/config/helpers.js'
import { mapState } from 'vuex'
import { actionButtons } from '../../../views/mixins/action-buttons.js'
import cloneDeep from 'lodash/cloneDeep'
import { QUERY_GET_EMAIL_CAMPAIGN_BY_ID } from '@/modules/campanhas/campanhas-email/graphql'
import offerScheduleCampaign from '@/modules/campanhas/views/mixins/offer-schedule-campaign.js'
import CbmCard from '@/components/CbmCard.vue'
export default {
  components: {
    CbmCard,
    BasePageLayout: () => import('@/components/BasePageLayout.vue'),
    InfoCard: () => import('@/modules/campanhas/views/components/ResultadosInfoCard.vue'),
    Funnel: () => import('@/modules/campanhas/views/components/results/Funnel.vue'),
    ProductsTable: () => import('@/modules/campanhas/views/components/results/ProductsTable.vue'),
    EmailPreview: () => import('@/modules/campanhas/campanhas-email/views/components/EmailPreview.vue'),
  },

  mixins: [actionButtons, offerScheduleCampaign],

  data: () => ({
    locale: localeString,
    loading: true,
    redirectPage: 'email',

    loadingMetrics: false,
    loadingDialog: false,
    metrics: {},
    campaignUnitIds: [],
    campaignId: '',
    campaign: {
      title: '',
      description: '',
      products: [],
      segments: [],
      initial_date: '',
      final_date: '',
      status: 'DRAFT',
      template_id: '',
      message: {
        subject: '',
        header_image: null,
        text: '',
        image: null,
        click_to_call_button_text: '',
        click_to_call_button_link: '',
        footer: '',
        send_date: '',
        send_time: '',
      },
      offers_schedule_id: '',
      frequency: {
        type: 'ONETIME',
        interval: 1,
      },
    },
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    unitsConfiguration() {
      return this.stateFilters.unitsConfiguration
    },
    totalDelivered() {
      return this.campaign.metrics ? this.campaign.message.sendings[0].total : 0
    },
    deliveredEmails() {
      return this.campaign.metrics ? this.locale((this.campaign.message.sendings[0].delivered / this.campaign.message.sendings[0].total) * 100, 2) : 0
    },
    cards() {
      return [
        {
          value: this.locale(this.metrics?.clients_metrics?.opened_and_bought?.count || 0),
          text: 'Clientes que abriram e compraram',
          underText: `${this.locale(
            this.getSafe(() => this.metrics?.clients_metrics?.opened_and_bought?.count / this.metrics?.general_metrics?.general?.messages_read) * 100 || 0,
            1
          )}%`,
          description: `dos ${this.locale(this.metrics?.general_metrics?.general?.messages_read || 0)} clientes que abriram`,
          helpText: 'Quantidade de clientes que abriram o e-mail e realizaram pelo menos uma compra no período de mensuração',
          isInteger: true,
        },
        {
          value: this.locale(this.metrics?.clients_metrics?.opened_and_bought?.average_ticket || 0, 2),
          text: 'Ticket médio dos clientes que abriram',
          underText: `${this.locale(this.metrics?.analytic_metrics?.average_ticket_received_variation || 0, 1)}%`,
          description: `a ${this.metrics?.analytic_metrics?.average_ticket_received_variation > 0 ? 'mais' : 'menos'} do que quem não recebeu`,
          helpText:
            'Ticket médio dos clientes que abriram o e-mail e realizaram pelo menos uma compra no período de mensuração em comparação com o ticket médio dos consumidores do clube no mesmo período dessa campanha',
          isCurrency: true,
        },
        {
          value: this.locale(this.metrics?.clients_metrics?.opened_and_bought?.revenue || 0, 0),
          text: 'Faturamento dos clientes que abriram',
          underText: `${this.locale(
            this.getSafe(() => this.metrics?.clients_metrics?.opened_and_bought?.revenue / this.metrics?.clients_metrics?.total?.revenue) * 100 || 0,
            1
          )}%`,
          description: `do faturamento total`,
          helpText:
            'Faturamento dos clientes que abriram o e-mail e realizaram pelo menos uma compra no período de mensuração em comparação com o faturamento dos consumidores do clube no mesmo período dessa campanha',
          isCurrency: true,
          isInteger: true,
        },
        {
          value: this.locale(this.metrics?.analytic_metrics?.opened_roi || 0),
          text: 'Alavancagem dos clientes que abriram',
          helpText: 'Faturamento gerado para cada real investido na campanha',
          underText: `R$ ${this.locale(this.metrics?.analytic_metrics?.price || 0, 2)}`,
          description: `investimento da campanha`,
          isInteger: true,
        },
      ]
    },
    cardsDisparo() {
      return [
        {
          text: 'E-mails entregues',
          value: this.locale(this.metrics?.general_metrics?.general?.messages_received || 0),
          underText: `${this.locale(
            this.getSafe(() => this.metrics?.general_metrics?.general?.messages_received / this.metrics?.general_metrics?.general?.messages_sent) * 100 || 0,
            1
          )}%`,
          description: `dos ${this.locale(this.metrics?.general_metrics?.general?.messages_sent || 0)} e-mails enviados`,
          isInteger: true,
        },
        {
          text: 'Cliques no botão',
          value: this.locale(this.metrics?.general_metrics?.general?.messages_clicked || 0),
          underText: `${this.locale(
            this.getSafe(() => this.metrics?.general_metrics?.general?.messages_clicked / this.metrics?.general_metrics?.general?.messages_read) * 100 || 0,
            1
          )}%`,
          description: `dos ${this.locale(this.metrics?.general_metrics?.general?.messages_read || 0)} e-mails abertos`,
          isInteger: true,
        },
        {
          text: 'Desistências',
          value: this.locale(this.metrics?.contacts_metrics?.blacklisted_quantity || 0),
          underText: `${this.locale(
            this.getSafe(() => this.metrics?.contacts_metrics?.blacklisted_quantity / this.metrics?.general_metrics?.general?.messages_read) * 100 || 0,
            1
          )}%`,
          description: `dos ${this.locale(this.metrics?.general_metrics?.general?.messages_read || 0)} e-mails abertos`,
          isInteger: true,
        },
        {
          text: 'Créditos usados',
          value: this.locale(this.metrics?.analytic_metrics?.credits),
          underText: `${this.locale(this.metrics?.analytic_metrics?.validation_credits)}`,
          description: `usados para validar ${this.locale(this.metrics?.contacts_metrics?.validated_quantity)} e-mails`,
          isInteger: true,
        },
      ]
    },
    headersMetricas() {
      return [
        {
          text: '',
          sortable: false,
        },
        {
          text: 'Clientes',
          sortable: false,
          align: 'right',
        },
        {
          text: 'Percentual dos atingidos',
          sortable: false,
          align: 'right',
        },
        {
          text: 'Faturamento',
          sortable: false,
          align: 'right',
        },
        {
          text: 'Ticket médio',
          sortable: false,
          align: 'right',
        },
        {
          text: 'Cupons',
          sortable: false,
          align: 'right',
        },
      ]
    },
    units() {
      return this.stateFilters.units || []
    },
  },
  watch: {
    $route(route) {
      if (route.params?.id?.length !== 24 && route.query?.quick_action) {
        // Reset the data
        Object.assign(this.$data, this.$options.data.apply(this))
      }
    },
  },
  async mounted() {
    this.campaignId = this.$route.params.id
    if (this.campaignId?.length !== 24) this.campaignId = ''
    try {
      this.loadingDialog = true
      await this.getCampaign()
      await this.getCampaignMetrics()
    } catch (error) {
      console.log(error)
    } finally {
      this.loadingDialog = false
    }
    if (this.campaign.messages_queues) this.formatData()

    this.$bus.$on('filter', this.handleFilterEvent)
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    handleFilterEvent(payload = {}) {
      if (payload.isInitialLoad) return
      this.getCampaignMetrics()
    },
    toDecimal(value) {
      return value.toFixed(2).replace('.', ',')
    },
    async getCampaign() {
      const {
        data: { campaign },
      } = await this.$apollo.query({
        query: QUERY_GET_EMAIL_CAMPAIGN_BY_ID,
        notifyOnNetworkStatusChange: true,
        context: {
          uri: this.$microservicesUrls['campaigns'],
        },
        variables: {
          id: this.campaignId,
        },
        fetchPolicy: 'no-cache',
      })
      let newCampaign = cloneDeep(campaign)

      if (newCampaign && newCampaign.segments) {
        newCampaign.segments = newCampaign.segments.map((segment) => {
          segment.updating = false
          return segment
        })
      }

      if (newCampaign?.offers_schedule && Object.entries(newCampaign.offers_schedule).length) {
        newCampaign = { ...newCampaign, offers_schedule_id: newCampaign.offers_schedule._id }
        this.offerSchedule = newCampaign.offers_schedule
      } else {
        newCampaign = { ...newCampaign, offers_schedule_id: '' }
        this.offerSchedule = {}
      }

      delete newCampaign.offers_schedule
      this.campaign = cloneDeep(newCampaign)
      if (newCampaign.units?.length) this.campaignUnitIds = newCampaign.units.map((unit) => unit.id_erp)
    },
    async getCampaignMetrics() {
      console.log('getCampaignMetrics')
      try {
        this.loadingMetrics = true
        const {
          data: { campaign },
        } = await this.$apollo.query({
          query: QUERY_GET_CAMPAIGN_METRICS,
          notifyOnNetworkStatusChange: true,
          variables: {
            id: this.campaign._id,
            units: this.units,
          },
          context: {
            uri: this.$microservicesUrls['campaigns'],
          },
          fetchPolicy: 'no-cache',
        })
        if (!campaign) return
        this.sendings = campaign?.message?.sendings || []
        this.metrics = campaign.metrics
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingMetrics = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.card-metricas-email {
  min-width: 270px;
}
</style>
